import React, { useEffect, useState } from "react";
import { Wrench, X } from "lucide-react";
import api from "@/lib/api";

export const MaintenanceBanner = () => {
  const [m, setM] = useState(null);
  const [hidden, setHidden] = useState(false);
  const [, setTick] = useState(0);

  useEffect(() => {
    const load = () => api.get("/public/maintenance").then((r) => setM(r.data.scheduled ? r.data : null)).catch(() => {});
    load();
    const t = setInterval(load, 120000);
    const t2 = setInterval(() => setTick((x) => x + 1), 30000);
    return () => { clearInterval(t); clearInterval(t2); };
  }, []);

  if (!m) return null;
  const now = Date.now();
  const startMs = new Date(m.start).getTime();
  const endMs = new Date(m.end).getTime();
  const active = now >= startMs && now <= endMs;
  const nice = (s) => (s || "").replace("T", " ");

  if (active) {
    return (
      <div className="px-4 py-2.5 bg-[#0047AB] text-white" data-testid="maintenance-banner-active">
        <div className="max-w-7xl mx-auto flex items-center gap-3 text-sm">
          <Wrench className="w-4 h-4 shrink-0 animate-pulse" />
          <span className="flex-1"><b>Maintenance in progress</b> — {m.message} Back by <b>{nice(m.display_end)}</b> (UK time).{m.pause_checkout ? " Checkout is briefly paused — your basket is saved." : ""}</span>
        </div>
      </div>
    );
  }
  if (hidden || sessionStorage.getItem(`maint_${m.start}`)) return null;
  const mins = Math.max(0, Math.round((startMs - now) / 60000));
  const cd = mins >= 1440 ? `${Math.floor(mins / 1440)}d ${Math.floor((mins % 1440) / 60)}h` : mins >= 60 ? `${Math.floor(mins / 60)}h ${mins % 60}m` : `${mins}m`;
  return (
    <div className="px-4 py-2.5 bg-[#FFC107] text-[#1a1a1a]" data-testid="maintenance-banner-scheduled">
      <div className="max-w-7xl mx-auto flex items-center gap-3 text-sm">
        <Wrench className="w-4 h-4 shrink-0" />
        <span className="flex-1"><b>Scheduled maintenance</b> {nice(m.display_start)} → {nice(m.display_end)} (starts in {cd}). {m.message} Please complete orders and work beforehand.</span>
        <button onClick={() => { sessionStorage.setItem(`maint_${m.start}`, "1"); setHidden(true); }} className="shrink-0 opacity-70 hover:opacity-100" aria-label="Dismiss" data-testid="maintenance-banner-dismiss"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
